import {Link} from 'react-router-dom'
import {BsStarFill} from 'react-icons/bs'
import './index.css'

const SimilarProductItem = props => {
  const {productDetails} = props
  const {id, title, brand, imageUrl, rating, price} = productDetails

  return (
    <li className="similar-product-item">
      <Link to={`/products/${id}`} className="similar-product-link">
        <img
          src={imageUrl}
          className="similar-product-img"
          alt={`similar product ${title}`}
        />
        <p className="similar-product-title">{title}</p>
        <p className="similar-products-brand">by {brand}</p>
        <div className="similar-product-price-rating-container">
          <p className="similar-product-price">Rs {price}/-</p>
          <div className="similar-product-rating-container">
            <p className="similar-product-rating">{rating}</p>
            <BsStarFill color="#ffffff" size={14} className="similar-product-star" />
          </div>
        </div>
      </Link>
    </li>
  )
}

export default SimilarProductItem
